<template>
    <ul class="af-login-widget-menu afu-flex afu-flex-col afu-m-0 afu-p-0 afu-list-none afu-w-64 afu-rounded-lg afu-shadow-lg afu-px-5 afu-py-2 afu-bg-white afu-text-left">
        <li
            v-for="nav in navs"
            :key="nav.label"
            class="af-login-widget-nav-item afu-border-b afu-border-t-0 afu-border-r-0 afu-border-l-0 afu-border-solid afu-border-gray-300 last:afu-border-b-0"
        >
            <a
                :href="nav.route_url"
                class="af-login-widget-nav-link afu-text-lg md:afu-text-base afu-block afu-text-black hover:afu-text-primary-400 afu-px-o afu-py-4 md:afu-py-3 afu-no-underline hover:afu-no-underline"
                :class="{ 'afu-text-primary-400': checkUrl(nav.route_url) }"
            >
                <span class="afu-mr-3">
                    <FontAwesomeIcon
                        :icon="nav.icon"
                        class="afu-text-primary-400"
                    />
                </span>
                {{ nav.label }}
            </a>
        </li>

        <li class="af-login-widget-nav-item afu-border-b afu-border-t-0 afu-border-r-0 afu-border-l-0 afu-border-solid afu-border-gray-300 last:afu-border-b-0">
            <a
                href="#"
                class="af-login-widget-nav-link afu-text-lg md:afu-text-base afu-block afu-text-gray-600 afu-text-black hover:afu-text-primary-400 afu-px-o afu-py-4 md:afu-py-3 afu-no-underline hover:afu-no-underline"
                @click.stop.prevent="logout()"
            >
                <span class="afu-mr-3">
                    <FontAwesomeIcon :icon="['far', 'sign-out']" />
                </span>
                Logout
            </a>
        </li>
    </ul>
</template>

<script>
    import Cookie from '@/services/cookie';

    export default {
        name: 'SeekerMenu',

        data() {
            return {
                navs: [
                    { label: this.$t('dashboard_menu.applications'), route_name: 'applications', route_url: '/user-dashboard/applications/', icon: ['far', 'check-circle'] },
                    { label: this.$t('dashboard_menu.saved_jobs'), route_name: 'saved-jobs', route_url: '/user-dashboard/saved-jobs/', icon: ['far', 'heart'] },
                    { label: this.$t('dashboard_menu.job_alerts'), route_name: 'job-alerts', route_url: '/user-dashboard/job-alerts/', icon: ['far', 'bell'] },
                    { label: this.$t('dashboard_menu.profile_details'), route_name: 'profile', route_url: '/user-dashboard/profile/', icon: ['far', 'user-circle'] },
                    { label: this.$t('dashboard_menu.work_preferences'), route_name: 'work-preferences', route_url: '/user-dashboard/work-preferences/', icon: ['far', 'briefcase'] },
                    { label: this.$t('dashboard_menu.documents'), route_name: 'documents', route_url: '/user-dashboard/documents/', icon: ['far', 'file-alt'] },
                    { label: this.$t('dashboard_menu.account_settings'), route_name: 'settings', route_url: '/user-dashboard/settings/', icon: ['far', 'cog'] },
                ],
            };
        },

        methods: {
            checkUrl(routeUrl) {
                if (!window && !window.location) {
                    return false;
                }

                return routeUrl === window.location.pathname;
            },

            logout() {
                Cookie.deleteToken();
                window.location.href = '/';
            },
        },
    };
</script>
